export const disableLinktoMatch = (sportId, compId) => {
  switch (sportId) {
    case '1':
      switch (compId) {
        case 616:
          return true;
        default:
          return false;
      }
    case '5':
      return true;
    default:
      return false;
  }
};



// WEBPACK FOOTER //
// ./src/utils/linkManagement.js